module.exports = __webpack_public_path__ + "static/media/S (148).8eb95f54.jpg";